// extracted by mini-css-extract-plugin
export default {"footerComponent":"Footer_footerComponent__xa5Um"};